var _g, _path, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSsoBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1060,
    height: 90,
    viewBox: "14 9 1060 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4727_3266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4463 17.2063C14.4463 12.788 18.028 9.2063 22.4463 9.2063H1065.75C1070.17 9.2063 1073.75 12.788 1073.75 17.2063V91C1073.75 95.4183 1070.17 99 1065.75 99H22.4463C18.028 99 14.4463 95.4183 14.4463 91V17.2063Z",
    fill: "#700AC1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4727_3266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 1060,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4463 9.7063H1069.75C1071.68 9.7063 1073.25 11.2733 1073.25 13.2063V95.0002C1073.25 96.9331 1071.68 98.5002 1069.75 98.5002H18.4463C16.5134 98.5002 14.9464 96.9331 14.9463 95.0002V13.2063C14.9463 11.2733 16.5133 9.7063 18.4463 9.7063Z",
    fill: "#4A3AFF",
    stroke: "#EFF0F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4727_3266)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M767.725 9.47548C765.515 9.47548 763.686 11.2845 764.14 13.4466C764.898 17.0603 766.689 20.6075 769.468 23.9773C773.26 28.575 778.818 32.7525 785.825 36.2714C792.831 39.7903 801.149 42.5816 810.304 44.486C819.459 46.3904 829.27 47.3706 839.179 47.3706C849.088 47.3706 858.9 46.3904 868.055 44.486C877.209 42.5816 885.527 39.7903 892.534 36.2714C899.54 32.7525 905.098 28.575 908.89 23.9773C911.67 20.6074 913.46 17.0603 914.219 13.4465C914.672 11.2845 912.843 9.47546 910.634 9.47546L839.179 9.47548L767.725 9.47548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M781.043 62.0745C783.253 62.0745 785.077 63.8788 784.688 66.0534C783.888 70.5259 781.741 74.9196 778.307 79.0825C773.86 84.4747 767.341 89.3742 759.124 93.5012C750.907 97.6282 741.151 100.902 730.414 103.135C719.678 105.369 708.17 106.519 696.549 106.519C684.928 106.519 673.42 105.369 662.684 103.135C651.947 100.902 642.191 97.6282 633.974 93.5012C625.756 89.3742 619.238 84.4747 614.791 79.0825C611.357 74.9196 609.21 70.5259 608.41 66.0534C608.021 63.8788 609.845 62.0745 612.054 62.0745L696.549 62.0745L781.043 62.0745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 914.613,
    y: 27.1655,
    width: 76.0606,
    height: 151.45,
    rx: 4,
    transform: "rotate(90 914.613 27.1655)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M772.692 155C768.451 155 767.125 149.267 770.936 147.406L840.171 113.586L908.691 78.1001C911.353 76.7212 914.53 78.6537 914.53 81.6521L914.53 151C914.53 153.209 912.739 155 910.53 155L772.692 155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.07,
    cx: 994.018,
    cy: 79.3958,
    rx: 25.3494,
    ry: 79.2874,
    transform: "rotate(90 994.018 79.3958)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.7501 19C14.7501 13.4771 19.228 8.98796 24.7495 9.11375C39.8058 9.45677 54.6139 10.5728 68.5995 12.4254C85.6719 14.6869 101.184 18.0016 114.251 22.1802C127.317 26.3588 137.682 31.3196 144.754 36.7792C151.826 42.2389 155.465 48.0905 155.465 54C155.465 59.9095 151.826 65.7611 144.754 71.2208C137.682 76.6804 127.317 81.6412 114.251 85.8198C101.184 89.9984 85.6718 93.3131 68.5995 95.5746C54.6139 97.4272 39.8057 98.5432 24.7494 98.8862C19.228 99.012 14.7501 94.5228 14.7501 89L14.7501 54L14.7501 19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 1073.75,
    y: 3.46118,
    width: 50.8797,
    height: 159.143,
    rx: 4,
    transform: "rotate(90 1073.75 3.46118)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1028.73 9.2063C1033.31 9.2063 1034.29 15.6646 1029.91 17.0259L980.249 32.4703L919.886 52.3714C917.298 53.2245 914.633 51.2972 914.633 48.5725L914.633 13.2063C914.633 10.9971 916.424 9.20629 918.633 9.20629L1028.73 9.2063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4727_3266",
    x: 0.446289,
    y: 0.206299,
    width: 1087.3,
    height: 117.794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0323264 0 0 0 0 0.0598209 0 0 0 0 0.204167 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4727_3266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4727_3266",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsoBanner);
export default __webpack_public_path__ + "static/media/sso_banner.52971c8ecc804ffbef365ad5b59213a2.svg";
export { ForwardRef as ReactComponent };